"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPulmonaryFunctionTest = createPulmonaryFunctionTest;
const shared_1 = require("../../shared");
const queries_1 = require("../queries");
const messages = {
    pulmonaryFunctionTest: {
        id: "dashboard.pulmonary_function_test",
        defaultMessage: "Légzésfunkciós vizsgálat"
    },
    fev1: {
        id: "dashboard.fev1",
        defaultMessage: "FEV1"
    },
    fvc: {
        id: "dashboard.fvc",
        defaultMessage: "FVC"
    },
    pef: {
        id: "dashboard.pef",
        defaultMessage: "PEF"
    },
    mef75: {
        id: "dashboard.mef75",
        defaultMessage: "MEF75"
    }
};
const values = [
    {
        label: messages.fev1,
        query: queries_1.queries.fev1
    },
    {
        label: messages.fvc,
        query: queries_1.queries.fvc
    },
    {
        label: messages.pef,
        query: queries_1.queries.pef
    },
    {
        label: messages.mef75,
        query: queries_1.queries.mef75
    }
];
function createPulmonaryFunctionTest(intl, { events }) {
    return (0, shared_1.createList)(intl, {
        events,
        label: messages.pulmonaryFunctionTest,
        values,
        createItem: shared_1.createNumberListItem
    });
}
